export default "__VITE_ASSET__2ThRU$28__"